import { TitleCasePipe } from "@angular/common";
import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { FieldTree } from "@angular/forms/signals";
import { StrategyDspAudiencePreset, StrategyDspAudienceType, StrategyDspFunnel } from "@front/m19-api-client";
import { AudienceId } from "@front/m19-services";
import { TranslocoDirective } from "@jsverse/transloco";
import { DspAudiencePresetSelectorComponent } from "@m19-board/dsp/dsp-audience-preset-selector/dsp-audience-preset-selector.component";
import { DspAudiencesSelectorComponent } from "@m19-board/dsp/dsp-audiences-selector/dsp-audiences-selector.component";
import { DspSmartAudienceSelectorComponent } from "@m19-board/dsp/dsp-smart-audience-selector/dsp-smart-audience-selector.component";

export interface DspCreateStrategyAudiencesModel {
  audiencePreset: StrategyDspAudiencePreset;
  audiences: AudienceId[][];
  blacklistedAudiences: AudienceId[][];
}

@Component({
  selector: "app-dsp-create-strategy-audiences-step",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslocoDirective,
    TitleCasePipe,
    DspAudiencePresetSelectorComponent,
    DspAudiencesSelectorComponent,
    DspSmartAudienceSelectorComponent,
  ],
  templateUrl: "./dsp-create-strategy-audiences-step.component.html",
})
export class DspCreateStrategyAudiencesStepComponent {
  readonly audiences = input.required<FieldTree<DspCreateStrategyAudiencesModel>>();
  readonly funnel = input.required<StrategyDspFunnel | null>();

  readonly StrategyDspAudienceType = StrategyDspAudienceType;

  readonly isAwareness = computed(() => this.funnel() === StrategyDspFunnel.AWARENESS);

  readonly isManualPreset = computed(
    () => this.audiences().audiencePreset().value() === StrategyDspAudiencePreset.MANUAL,
  );

  selectAudiencePreset(audiencePreset: StrategyDspAudiencePreset) {
    this.audiences().audiencePreset().markAsDirty();
    this.audiences().audiencePreset().value.set(audiencePreset);
  }

  selectAudiences(value: AudienceId[][]) {
    this.audiences().audiences().markAsDirty();
    this.audiences().audiences().value.set(value);
  }

  selectBlacklistedAudiences(value: AudienceId[][]) {
    this.audiences().blacklistedAudiences().markAsDirty();
    this.audiences().blacklistedAudiences().value.set(value);
  }
}
